import React from 'react';
import { useParams, useNavigate } from 'react-router';
import { useResolveSlugQuery } from 'store/services/profile/profileApi';
import { ProfileTradeSidebarProvider } from 'screens/Public/UserProfile/context/ProfileTradeSidebarContext';
import { UserProfilePageInner } from 'screens/Public/UserProfile/UserProfilePage';
import LeftNavigationBar from 'screens/Main/components/LeftNavigationBar';
import Footer from 'components/Footer';

const SlugProfilePage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  const { data, isLoading, error } = useResolveSlugQuery(slug || '', {
    skip: !slug,
  });

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: '#0a0a0a', color: '#888' }}>
        Loading profile...
      </div>
    );
  }

  if (error || !data?.username) {
    const is404 = error && typeof error === 'object' && 'status' in error && error.status === 404;
    return (
      <div className="user-profile-layout">
        <div className="user-profile-content-wrapper">
          <LeftNavigationBar
            currentTab={{ path: '/profile', Component: <></> }}
            isPublicMode={true}
            isAuthenticated={false}
            isMobile={false}
            isMobileMenuOpen={false}
            onMenuClose={() => {}}
          />
          <div className="user-profile-main-area">
            <div className="user-profile-error">
              <div className="error-icon">{is404 ? '\uD83D\uDD0D' : '\u26A0\uFE0F'}</div>
              <h1 className="error-title">{is404 ? 'Profile Not Found' : 'Error Loading Profile'}</h1>
              <p className="error-message">
                {is404
                  ? 'This custom URL does not exist.'
                  : 'There was an error loading this profile. Please try again later.'}
              </p>
              <div style={{ display: 'flex', gap: '12px', marginTop: '20px', justifyContent: 'center' }}>
                <button
                  onClick={() => navigate('/home')}
                  style={{ padding: '10px 24px', borderRadius: '8px', border: 'none', background: '#7c3aed', color: '#fff', fontSize: '14px', fontWeight: 600, cursor: 'pointer' }}
                >
                  Go Home
                </button>
                <button
                  onClick={() => navigate(-1)}
                  style={{ padding: '10px 24px', borderRadius: '8px', border: '1px solid #333', background: '#1a1a1a', color: '#aaa', fontSize: '14px', fontWeight: 600, cursor: 'pointer' }}
                >
                  Go Back
                </button>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <ProfileTradeSidebarProvider>
      <UserProfilePageInner username={data.username} isSlugRoute />
    </ProfileTradeSidebarProvider>
  );
};

export default SlugProfilePage;
